import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategyEvolutionSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(): string {
    return 'parity-strategy/evolution';
  }
}
